window.bugsanddrugs = window.bugsanddrugs || {};

bugsanddrugs.resettiny = function () {
    tinymce.activeEditor.remove('#page_document_text')
    tinymce.init(tinymce.settings)
    bugsanddrugs.updateSortables()
    bugsanddrugs.updatedDirty = false
    bugsanddrugs.updateDirtyForm(true)
}

bugsanddrugs.highlightnav = function () {
    $('.hlnav').removeClass('hlnavon')
    let index_id = $("#index-entry-page-id-helper").val() || false
    if (index_id !== false) {
        let ie = $('#highlight-entry-' + index_id)
        $(ie).addClass('hlnavon')
    }
}

bugsanddrugs.closeOpenParent = function (p, doParent) {
    let n = $('#open-' + p)
    $.get('/pages/show_children/' + p, function (r) {
        eval(r)
    })
}

$(document).on('click', "#togglemeta", function (e) {
    e.preventDefault();
    $('#togglemeta_div').toggle();
    return false
})

// new sub page
$(document).on('click', "#new_sub_page_form_toggle", function (e) {
    e.preventDefault();
    $('#sub_page_form').toggle();
    return false
})

$(document).on('click', "#sub_form_submit", function (e) {
    e.preventDefault();

    let t = $('#new_sub_page_title').val();
    let u = $('#new_sub_page_path').val();
    let page_type = $('#new_sub_page_type').val()
    let p = $('#page_path').val();

    $.post(u, { title: t, page_type: page_type }, function (d) {
        setTimeout(
            function () {
                let b = $('#busy_modal')
                b.modal('hide')
            }, 1200)
        $("#sub_page_modal").modal("hide");
        $(".modal-backdrop").remove();
        // refresh parent by fakeclick
        let p = $("#new_sub_page_parent").val();
        bugsanddrugs.closeOpenParent(p, true);
        html_page = document.getElementById("html_details")
        html_page.innerHTML = d
        setTimeout(bugsanddrugs.resettiny(), 750)
    })
})

$(document).on('click', ".copy_form_submit", function (e) {
    e.preventDefault();

    let t = $('#copy_sub_page_title').val();
    let u = $('#new_sub_page_path').val();
    let p = $('#copy_form_parent_target').val() || false;
    let pc = $('#copy_form_child_target').val() || false;
    let cc = $('#copy_page_children').val() == 'on' ? true : false;
    $('#busy_modal').modal('show')

    let o = {
        title: t,
        duplicate: true,
        parent_target: p,
        child_target: pc,
        copy_page_children: cc
    }

    $.post(u, o, function (d) {
        $('#copy_page_title').html(d.page_title)
        $('#copy_page_uuid').html(d.id)
        $('#copyTarget_copy').val(d.id)
        bugsanddrugs.closeOpenParent(d.parent_id)
        $("#copy_page_modal").modal('hide')
        setTimeout(
            function () {
                let b = $('#busy_modal')
                b.modal('hide')
            }, 1200)
    })
})

// delete page
$(document).on('click', "#delete_page_form_toggle", function (e) {
    e.preventDefault();
    $('#delete_page_form').toggle();
    return false
})

$(document).on('click', "#delete_form_submit", function (e) {
    e.preventDefault();
    let u = $('#delete_page_path').val() + '/delete';
    let c = $('#delete_page_children:checked').val() ? true : false
    let p = $('#delete_page_parent_id').val();

    setTimeout(
        function () {
            let b = $('#busy_modal')
            b.modal('hide')
        }, 1200)


    $.ajax({
        type: "POST",
        data: {
            delete_page_children: c
        },
        url: u,
        method: 'POST',
        success: function (r) {

            setTimeout(
                function () {
                    let b = $('#busy_modal')
                    b.modal('hide')
                }, 1200)

            $("#delete_page_modal").modal("hide");
            $(".modal-backdrop").remove();

            // refresh parent by fakeclick
            bugsanddrugs.closeOpenParent(p);

            html_page = document.getElementById("html_details")
            html_page.innerHTML = r

            setTimeout(bugsanddrugs.resettiny(), 750);

        },
        error: function (request, msg, error) {
            alert('Unable to delete page')
            setTimeout(
                function () {
                    let b = $('#busy_modal')
                    b.modal('hide')
                }, 1200)

            $('#delete_page_modal').modal('hide')
            $('.modal-backdrop').remove()
        }
    });

    return false
})

$(document).on('turbolinks:load', function () {
    // console.log('turbolinks load, init tiny')
    setTimeout(bugsanddrugs.resettiny(), 750);
    bugsanddrugs.highlightnav()
});

$(document).on('mousedown', "select[multiple] option", function (e) {
    let $self = $(this);
    if ($self.prop("selected"))
        $self.prop("selected", false);
    else
        $self.prop("selected", true);

    return false;
})


$(document).on('change', '#page_version', function (e) {
    let $self = $(this);
    let version = $self.val();
    let u = $('#edit_page_path').val();

    $.ajax({
        type: "GET",
        url: u + '/?version=' + version,
        success: function (r) {
            html_page = document.getElementById("html_details")
            html_page.innerHTML = r
            setTimeout(bugsanddrugs.resettiny(), 750)
        },
        error: function (request, msg, error) {
            alert('Unable to get version')
        }
    });
    return false
})

bugsanddrugs.copy = function (targetId) {
    let target = $('#' + targetId);
    let current_scroll = $(document).scrollTop();

    // Temporarily change the input type to "text"
    target.attr("type", "text");

    // Try using the Clipboard API first
    if (navigator.clipboard) {
        navigator.clipboard.writeText(target.val()).then(function () {
            alert("ID: " + target.val() + " In Clipboard");
        }).catch(function (err) {
            console.error('Unable to copy text using Clipboard API: ', err);
            useExecCommandFallback();
        });
    } else {
        useExecCommandFallback();
    }

    // Restore the input type and scroll position
    target.attr("type", "hidden");
    $(document).scrollTop(current_scroll);

    return false;

    function useExecCommandFallback() {
        try {
            target.focus().select();
            document.execCommand("copy");
            alert("ID: " + target.val() + " In Clipboard");
        } catch (e) {
            console.error('Unable to copy text using execCommand: ', e);
        }
    }
}

$(document).on('click', ".copyNavID", function (e) {
    e.preventDefault();

    let id = $(this).attr('data-id');
    $('#copyTarget_copyNavID').val(id);
    bugsanddrugs.copy("copyTarget_copyNavID");

    return false
})


bugsanddrugs.updateSortables = function () {
    // in case one is still loaded
    $('.selector').sortable('destroy')

    $('.child-pages').sortable({
        containment: "parent",
        tolerance: 'pointer',
        update: function (event, ui) {

            let r = confirm('Complete this reordering')
            if (r == true) {
                // moved item 
                // ui.item
                // ui.item[0].parent    // html parent of this, should be our container to change display_order in
                // get parent, child ids, send to server for update
                let item = ui.item[0]
                let parent = item.parentElement
                let parentid = parent.id.replace('index-entry-', '').replace('child-entry-', '').replace('child-pages-', '')

                let childIDS = []
                $(parent).children().each(function (k, v) {
                    let id = v.id.replace('index-entry-', '').replace('child-entry-', '').replace('child-pages-', '')
                    childIDS.push(id)
                })

                if (bugsanddrugs.checkDirty()) {
                    bugsanddrugs.setDisplayOrder(parentid, childIDS)
                }
            } else {
                $('.child-pages').sortable('cancel')
            }

        }
    });
}

bugsanddrugs.setDisplayOrder = function (parentid, children) {

    $.ajax({
        type: "POST",
        data: {
            parentid: parentid,
            children: children
        },
        url: '/pages/setdisplayorder',
        method: 'POST',
        success: function (r) {
            html_page = document.getElementById("html_details")
            html_page.innerHTML = r
            setTimeout(bugsanddrugs.resettiny(), 750)
        },
        error: function (e) {

        }
    })
}

bugsanddrugs.tableRowColouring = function () {

    // console.log('fix table stripe colouring')

    let a = $('#page_document_text').text()
    let div = document.createElement('div');
    div.innerHTML = a

    let c = div.firstChild
    if (div.firstChild.data && div.firstChild.data.includes("\n")) {
        c = div.firstChild.nextSibling;
    }

    if (!c) {
        return
    }

    let tds = c.querySelectorAll("td, th");
    let groups = [];
    let rows = c.querySelectorAll("tr");
    for (let i = 0; i < rows.length; i++) {
        rows[i].classList.remove("stripe");
    }


    for (let i = 0; i < tds.length; i++) {
        if (tds[i].getAttribute("rowspan") != null) {
            let rspan = tds[i];
            groups.push({
                parent: rspan.parentNode,
                height: rspan.getAttribute("rowspan")
            });
        }
    }

    let count = 0;
    let dark = true;


    for (let i = 0; i < rows.length; i++) {
        let row = rows[i];
        let index = groupIndex(row);
        if (index != null && dark) {
            let group = groups[index];
            let height = parseInt(group.height);
            for (let j = i; j < i + height; j++) {
                rows[j].classList.add("stripe");
            }
            i += height - 1;
            dark = !dark;
            continue;
        }
        if (dark) {
            rows[i].classList.add("stripe");
        }
        dark = !dark;
    }

    function groupIndex(element) {
        for (let i = 0; i < groups.length; i++) {
            let group = groups[i].parent;
            if (group == element) {
                return i;
            }
        }
        return null;
    }

    if (rows.length > 0 || tds.length > 0) {
        $("#page_document_text").text(c.outerHTML);
    }

}

bugsanddrugs.updateSortables()